<template>
    <div v-if="hasAlcohol || isBio || isHalal || isVegan" class="flex items-center gap-2 text-current">
        <ToolTip
            v-if="isHalal"
            :aria-id="`modifiers-${id}-halal`"
        >
            <Icon
                :icon="IconAllergyHalal"
                :auto-align="true"
                class="cursor-pointer text-xl text-gray-600"
            />
            <template #popper>
                <div v-html="te('shopPage.allergies.halal') ? t('shopPage.allergies.halal') : 'Missing description for allergy halal'" />
            </template>
        </ToolTip>
        <ToolTip
            v-if="hasAlcohol"
            :aria-id="`modifiers-${id}-alcohol`"
        >
            <Icon
                :icon="IconAllergyAlcohol"
                :auto-align="true"
                class="cursor-pointer text-xl text-gray-600"
            />
            <template #popper>
                <div v-html="te('shopPage.allergies.alcohol') ? t('shopPage.allergies.alcohol') : 'Missing description for allergy alcohol'" />
            </template>
        </ToolTip>
        <ToolTip
            v-if="isBio"
            :aria-id="`modifiers-${id}-bio`"
        >
            <Icon
                :icon="IconAllergyBio"
                :auto-align="true"
                class="cursor-pointer text-xl text-gray-600"
            />
            <template #popper>
                <div v-html="te('shopPage.allergies.bio') ? t('shopPage.allergies.bio') : 'Missing description for allergy bio'" />
            </template>
        </ToolTip>
        <ToolTip
            v-if="isVegan"
            :aria-id="`modifiers-${id}-vegan`"
        >
            <Icon
                :icon="IconAllergyVegan"
                :auto-align="true"
                class="cursor-pointer text-xl text-gray-600"
            />
            <template #popper>
                <div v-html="te('shopPage.allergies.vegan') ? t('shopPage.allergies.vegan') : 'Missing description for allergy vegan'" />
            </template>
        </ToolTip>
    </div>
</template>

<script setup lang="ts">
    import type { ProductInfoProps } from '~/types/local-types'
    import IconAllergyAlcohol from '~/assets/icons/allergy-alcohol.svg'
    import IconAllergyBio from '~/assets/icons/allergy-bio.svg'
    import IconAllergyHalal from '~/assets/icons/allergy-halal.svg'
    import IconAllergyVegan from '~/assets/icons/allergy-vegan.svg'
    import Icon from '~/components/Icon.vue'
    import ToolTip from '~/components/ToolTip.vue'
    defineProps<ProductInfoProps>()
    // TODO: probably not needed if we switch to $t and $te in the template
    const { t, te } = useI18n()
</script>
